import { useMemo, useState } from 'react';

export function useProgress({ total: baseTotal }: { total?: number }) {
  const [total, setTotal] = useState(baseTotal);
  const [index, setIndex] = useState<number>(0);
  const [customPercent, setCustomPercent] = useState(0);

  const percent = useMemo(() => {
    return customPercent || Math.ceil((index / total) * 100);
  }, [customPercent, index, total]);

  return { percent, total, setCustomPercent, setIndex, setTotal };
}
